export const environment = {
    production: true,
    baseUrl: 'https://preprod-wisee.srdi.net/api',
    boPath: '/bo',
};
